export default __webpack_public_path__ + "static/media/screen_livechat_03.31963fb3.png";